export * from './resource.model';
export * from './resource-popup.service';
export * from './resource.service';
export * from './resource-dialog.component';
export * from './resource-delete-dialog.component';
export * from './resource-detail.component';
export * from './resource.component';
export * from './resource.route';



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/resource/index.ts